export default "__VITE_ASSET__9e24479c__"